import {useCallback} from 'react';

export const useLogsHelper = () => {
    const getChipColorByLogType = useCallback((status: string) => {
        switch (status) {
            case 'Update':
                return 'warning';
            case 'Create':
                return 'success';
            case 'Move':
                return 'info';
            case 'RemoveComment':
                return 'error';
            case 'UpdateComment':
                return 'warning';
            default:
                return 'default';
        }
    }, []);

    return {
        getChipColorByLogType,
    };
};
